
import './screen.scss';
import { env } from './environment';

// Configure InstUI Theme (InstUI 8 / emotion: build the theme object here and
// apply it via <InstUISettingsProvider theme={instuiTheme}> at the React mount
// point. Replaces the deprecated themeable `theme.use({ overrides })` mechanism;
// brand overrides are merged over the canvas theme, preserving prior behavior.)
import { theme as canvasTheme } from '@instructure/canvas-theme'
export const instuiTheme = { ...canvasTheme, ...env.brand_variables };

// Configure Sentry
import * as Sentry from '@sentry/browser';
if (env.environment != 'development') {
    Sentry.init({
        dsn: env.sentry_dsn,
        environment: env.environment,
    });
}

// Configure MobX
import * as mobx from 'mobx';
mobx.configure({
    enforceActions: 'observed',
})

// Configure Moment
import moment from 'moment-timezone';
moment.tz.setDefault(env.timezone || moment.tz.guess());
